<template lang="pug">
  p-text-field.p-input-hour-minute(
    :label="label",
    :name="name",
    ref="input"
    type="text",
    v-model="inputValue",
    :disabled="disabled",
    v-mask="'##:##'"
    v-on="localListeners",
    v-bind="localAttributes"
    @focus="onFocus",
    @input="onChange",
    :error="errorMsg || error"
  )

</template>

<script>
import PTextField from './PTextField.vue'
import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import { mask } from 'vue-the-mask'
import { floatToHoursMins, inputTimeTofloat, floatToHoursMinsString } from 'src/utils'

export default {
  name: 'PInputHourMinute',
  props: {
    disabled: Boolean,
    label: { type: String, required: true },
    name: { type: String, required: true },
    error: String
  },
  created () {
    this.inputValue = floatToHoursMinsString(this.state.float)

    this.localListeners = Object.keys(this.$listeners)
      .filter(key => key !== 'input')
      // eslint-disable-next-line no-sequences
      .reduce((res, key) => (res[key] = this.$listeners[key], res), {}) // eslint-disable-line no-return-assign

    this.localAttributes = Object.keys(this.$attrs)
      .filter(key => key !== 'name' && key !== 'disabled')
      // eslint-disable-next-line no-sequences
      .reduce((res, key) => (res[key] = this.$attrs[key], res), {}) // eslint-disable-line no-return-assign
  },
  data () {
    return {
      touch: false,
      inputValue: '',
      localListeners: undefined,
      localAttributes: undefined
    }
  },
  computed: {
    errorMsg () {
      if (this.inputValue.length !== 5 || parseInt(this.inputValue.slice(3, 5)) >= 60) {
        return 'valor inválido'
      }
      return ''
    }
  },
  methods: {
    onChange (value) {
      this.touch = true
      if (!this.errorMsg) {
        const float = inputTimeTofloat(value)
        this.__state = floatToHoursMins(float)
      }
    },
    onFocus () {
      this.touch = false
      this.$refs.input.select()
    },
    updateValueWithFloat (float) {
      this.inputValue = floatToHoursMinsString(float)
    }
  },
  mixins: [handlerUseStateVmodel()],
  directives: { mask },
  components: {PTextField}
}
</script>

<style scoped>
.p-input-hour-minute {
  width: fit-content;
}
</style>
